export default {
	rtl: false
}
